<template>
  <div>
    <template v-if='!currentClient || currentClient.id != $route.params.client_id'>
      <Loader></Loader>
    </template>
    <template v-else>

      <div class="jumbotron" style='padding-left: 20px; padding-right: 20px;'>
        <div class="row">
          <div class="col-md-10 text-left">
            <h2>
              {{currentClient.firstname}} {{currentClient.lastname}}
            </h2>
            <br>
            <dl>
              <dt>Client Code:</dt>
              <dd>{{currentClient.client_code}}</dd>
              <dt>Company:</dt>
              <dd>{{currentClient.company}}</dd>
            </dl>
          </div>
          <div class="col-md-2">
            <!-- TODO: change to use v-dropdown -->
            <button-dropdown ref="configsDropdown">
              <template slot=dropdownAction>
                <i class="glyphicon glyphicon-cog"></i>
              </template>
              <template slot=default>
                <li><a href="#" class="btn-danger" @click="confirmClearClientDb">Clear Client DB</a></li>
              </template>
            </button-dropdown>
            <br>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="actions-panel">
              <h2>Actions</h2>
              <div class="panel-body" v-if="currentClient.id">
                <router-link class="btn btn-default"
                             :to="createConsultUrlParams('general_farm_consult')">
                  Create General Farm Consult
                </router-link>
                <router-link class="btn btn-default"
														 :event="''"
														 disabled
                             :to="createConsultUrlParams('winter_consult')">
                  Create Winter Consult
                </router-link>
                <router-link class="btn btn-default"
                             :event="currentClient.can_create_spring_consult ? 'click' : ''"
                             :disabled="!currentClient.can_create_spring_consult"
                             :to="createConsultUrlParams('spring_consult')">
                  Create Spring Consult
                </router-link>
                <router-link class="btn btn-default"
                             :event="currentClient.can_create_dry_cow_consult ? 'click' : ''"
                             :disabled="!currentClient.can_create_dry_cow_consult"
                             :to="createConsultUrlParams('dry_cow_consult')">
                  Create Dry Cow Consult
                </router-link>
                <router-link class="btn btn-default"
                             :to="{name: 'client_reports', params: {client_id: currentClient.id}}"
                             :event="( canView ) ? 'click' : ''"
                             :disabled="( !canView )">
                  Reports
                </router-link>
                <router-link class="btn btn-default"
                             v-if="isFonterraClient"
                             :to="{name: 'fonterra_report', params: {client_id: currentClient.id}}"
                             :event="( isFonterraClient ) ? 'click' : ''"
                             :disabled="( !isFonterraClient)">
                  Create New CD Report
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <pending-consults :filter-by-client="currentClient.id" ref="pending_consults"></pending-consults>

      <br>
      <br>

      <h2>History of Consults</h2>
      <div class="row text-left">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Opened date</th>
              <th>Submitted date</th>
              <th>Consult</th>
              <th>Vet</th>
              <th>Client Consulter</th>
              <th>Consult</th>
              <!-- <th>Summary Report</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="consult in consults" :key="`${consult.consult_type_slug}-${consult.id}`">
              <td>{{ consult.consult_opened_date | formatedDate }}</td>
              <td>{{ consult.date | formatedDate }}</td>
              <td>
                {{ consult.consult_type }}
                <template v-if="consult.state == 'saving'">
                  <i class="glyphicon glyphicon-warning-sign"
                     style='color: red; font-size: 1.1 em;'
                     v-tooltip="'This consult encountered errors when submitting, it is saved but needs fixing. Please contact an administrator.'"
                     >
                  </i>

                </template>
              </td>
              <td>{{consult.vet}}</td>
              <td>{{consult.client_consulter}}</td>
              <td>
                <router-link class="btn btn-default"
                             :disabled="consult.season_start_year < 2019"
                             :event="consult.season_start_year >= 2019 ? 'click' : ''"
                             :to="consultUrlParams(consult)">
                  View
                </router-link>
                <template v-if="isDryCowConsultAndCanReopen(consult)">
                  <router-link class="btn btn-default"
                               :to="consultUrlParams(consult, true)">
                    Reopen
                  </router-link>
                </template>
              </td>
              <!-- <td>
                <router-link class="btn btn-default"
                             :to="consultSummaryReportUrl(consult)"
                             v-if="consult.can_have_summary_report"
                             :event="consult.season_start_year >= 2019 ? 'click' : ''"
                             :disabled="consult.season_start_year < 2019">
                  Open
                </router-link>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { get_dairy_season_start_year, scrollToTop } from '../_helpers/utils';
import { indexedDB } from '../_helpers';
import PendingConsults from '../components/PendingConsults';
import ButtonDropdown from '../components/ButtonDropdown';

export default {
  data () {
    return {}
  },
  components: {
    ButtonDropdown,
    PendingConsults,
  },
  mounted() {
    scrollToTop()
    this.clearCurrentClient().then(() => {
      this.getClient(this.$route.params.client_id)
    })
  },
  filters: {
    formatedDate: function (dateString) {
      if (!dateString) return dateString
      // Date-only strings (e.g. "2026-03-31") have no timezone info and are
      // inconsistently parsed across browsers. Append "T00:00:00Z" to treat
      // them as UTC midnight, then display in NZ time like full timestamps.
      const isoString = /^\d{4}-\d{2}-\d{2}$/.test(dateString)
        ? dateString + 'T00:00:00Z'
        : dateString
      return new Intl.DateTimeFormat('en-NZ', {
        timeZone: 'Pacific/Auckland',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      }).format(new Date(isoString))
    }
  },
  methods: {
    ...mapActions('client', ['getClient', 'clearCurrentClient']),
    isDryCowConsultAndCanReopen: function (consult)
    {
      return (consult.consult_type_slug == 'dry_cow_consult' &&
        consult.season_start_year == get_dairy_season_start_year() &&
        consult.state == 'finished' &&
        this.user.is_farm_staff)
    },
    confirmClearClientDb: function ()
    {
      let numberOfPendingConsults = this.$refs.pending_consults.allPendingConsults.length
      let pendingConsultsMsg = (numberOfPendingConsults >= 1) ? `${numberOfPendingConsults} open consults will be deleted.` : ''
      if (confirm(`This will delete all open consults for client ${this.currentClient.firstname} ${this.currentClient.lastname}.\n ${pendingConsultsMsg}`))
      {
        this.cleanClientDbs(this.currentClient.id)
      }
      this.$refs.configsDropdown.close()
    },
    cleanClientDbs: function (clientId)
    {
      indexedDB.delete(clientId, 'winter-consult')
      indexedDB.delete(clientId, 'spring-consult')
      indexedDB.delete(clientId, 'spring-review')
      indexedDB.delete(clientId, 'dry-cow-consult')
      indexedDB.delete(clientId, 'general-farm-consult')
      this.$refs.pending_consults.refreshConsults()
    },
    createConsultUrlParams: function (consultType) {
      let season;

      if (consultType == 'general_farm_consult') {
        if (this.currentClient.last_gf_consult && this.currentClient.last_gf_consult.state == 'initial') {
          season = this.$moment(this.currentClient.last_gf_consult.consult_opened_date).format('YYYY-MM-DD')
        } else {
          season = this.$moment().format('YYYY-MM-DD')
        }
      } else {
        season = get_dairy_season_start_year({ forWinterConsult: ( consultType == 'winter_consult' ) })
      }
      return {
        name: consultType,
        params: {
          client_id: this.currentClient.id,
          season: season,
        }
      }
    },
    consultUrlParams: function (consult, canReopen=false)
    {
      let params = {
        name: consult.consult_type_slug,
        params: {
          client_id: this.currentClient.id,
        }
      }
      if (consult.consult_type_slug != 'general_farm_consult') {
        params.params['season'] = consult.season_start_year
      } else {
        params.params['season'] = consult.consult_opened_date
      }
      if (consult.state == 'finished' && !canReopen) { params['params']['history'] = 'history' }
      return params
    },
    consultSummaryReportUrl: function (consult) {
      return {
        name: `${consult.consult_type_slug}_summary_report`,
        params: {
          client_id: this.currentClient.id,
          season:
            consult.consult_type_slug == 'general_farm_consult'
              ? consult.consult_opened_date
              : consult.season_start_year,
        }
      }
    },
  },
  computed: {
    ...mapState('client', ['currentClient']),
    ...mapState('account', ['user']),
    isOwner: function () {
      return (this.user.client_ids.includes(this.currentClient.id) || this.user.is_superuser)
    },
    canView: function ()
    {
      return (this.user.client_ids.includes(this.currentClient.id) || this.user.is_superuser || this.user.is_farm_staff)
    },
    isFonterraClient: function ()
    {
      return this.currentClient && this.currentClient.fonterra_farms.length >= 1
    },
    consults: function () {
      return this.currentClient.consults
    }
  },
};
</script>
<style>
.actions-panel .btn { margin-right: 15px ;}
</style>

